/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 08.09.2016.
 */

import ShowcaseRelated from './showcase-related';

export default ShowcaseRelated;



// WEBPACK FOOTER //
// ./src/containers/ShowcaseRelated/index.js